/* One owner for GERHEL's custom forms; Shopify/apps retain their native handlers. */
(() => {
  if (window.GerhelCartDrawer) return;
  const rootPath = window.Shopify?.routes?.root || '/';
  const drawer = () => document.querySelector('[data-cart-drawer]');
  const roots = () => [...document.querySelectorAll('[data-gerhel-cart-section]')];
  const controls = '[data-cart-drawer-quantity], [data-cart-page-quantity], [data-cart-upsell-add], [data-cart-page-upsell-add], [data-cart-page-discount-apply], [data-cart-discount-form] button, [data-gerhel-cart-form] [data-add-to-cart], [data-gerhel-cart-section] [name="checkout"]';
  let busy = false, uncertain = false, returnFocus = null, draftCode = '', discountMessage = '', discountError = false;
  const disabled = new Map();
  const mobileSummary = window.matchMedia('(max-width: 749px)');
  function syncSummary() {
    document.querySelectorAll('[data-mobile-summary]').forEach(el => { el.open = !mobileSummary.matches; });
  }
  mobileSummary.addEventListener('change', syncSummary);
  const isOpen = () => drawer()?.classList.contains('is-open');
  function announce(text, error = false) {
    document.querySelectorAll('[data-gerhel-cart-status]').forEach(el => { el.textContent = text; el.classList.toggle('is-error', error); });
  }
  function lock(value) {
    busy = value;
    roots().forEach(el => el.setAttribute('aria-busy', String(value)));
    document.querySelectorAll(controls).forEach(el => {
      if (value) { if (!disabled.has(el)) disabled.set(el, el.disabled); if ('disabled' in el) el.disabled = true; el.setAttribute('aria-disabled', 'true'); }
      else { if ('disabled' in el) el.disabled = disabled.get(el) ?? false; el.removeAttribute('aria-disabled'); }
    });
    if (!value) disabled.clear();
  }
  function open() {
    const el=drawer(); if (!el) return;
    if (!isOpen()) returnFocus=document.activeElement;
    el.inert=false; el.classList.add('is-open'); el.setAttribute('aria-hidden','false');
    document.body.classList.add('custom-cart-drawer-open');
    el.querySelector('.custom-cart-drawer__close')?.focus({preventScroll:true});
  }
  function close() {
    if (!isOpen()) return;
    const el=drawer(); el.classList.remove('is-open'); el.setAttribute('aria-hidden','true'); el.inert=true;
    document.body.classList.remove('custom-cart-drawer-open');
    if (returnFocus?.isConnected) returnFocus.focus({preventScroll:true});
  }
  function restoreDiscount() {
    document.querySelectorAll('[data-cart-discount-input], [data-cart-page-discount-input]').forEach(el => { el.value=draftCode; });
    document.querySelectorAll('[data-cart-discount-message], [data-cart-page-discount-message]').forEach(el => { el.textContent=discountMessage; el.classList.toggle('is-error',discountError); });
  }
  function sectionIds() { return [...new Set(roots().map(el=>el.dataset.gerhelCartSection || 'drawer-cart'))]; }
  async function readCart() {
    const r=await fetch(`${rootPath}cart.js`,{cache:'no-store',headers:{Accept:'application/json'},signal:AbortSignal.timeout(15000)});
    if(!r.ok) throw new Error('No se pudo consultar el carrito.'); return r.json();
  }
  function badges(cart) {
    document.querySelectorAll('.top-navbar__cart-badge, [data-cart-count]').forEach(el=>{el.textContent=cart.item_count || ''; el.hidden=!cart.item_count;});
    const trigger=document.querySelector('[data-cart-drawer-trigger]');
    if(trigger && cart.item_count && !trigger.querySelector('.top-navbar__cart-badge')) { const el=document.createElement('span'); el.className='top-navbar__cart-badge'; el.textContent=cart.item_count; trigger.append(el); }
  }
  function render(sections) {
    const parsed=roots().map(el=>{
      const html=sections?.[el.dataset.gerhelCartSection || 'drawer-cart'];
      if(!html) throw new Error('Sección no disponible.');
      const next=new DOMParser().parseFromString(html,'text/html').getElementById(el.id);
      if(!next) throw new Error('Respuesta visual incompleta.'); return [el,next];
    });
    const summaryWasOpen=document.querySelector('[data-mobile-summary]')?.open;
    const focused=document.activeElement;
    const key=focused?.dataset.cartKey, label=focused?.getAttribute('aria-label');
    const focusId=focused?.id;
    parsed.forEach(([el,next])=>{
      // Scripts/styles belong to the original section; delegated handlers survive replacements.
      if(el.matches('[data-cart-drawer]')) el.querySelector('.custom-cart-drawer__panel').innerHTML=next.querySelector('.custom-cart-drawer__panel').innerHTML;
      else el.innerHTML=next.innerHTML;
    });
    syncSummary();
    if (summaryWasOpen !== undefined && document.querySelector('[data-mobile-summary]')) document.querySelector('[data-mobile-summary]').open=summaryWasOpen;
    restoreDiscount();
    if (busy) lock(true);
    let target=focusId ? document.getElementById(focusId) : null;
    if(key) target=[...document.querySelectorAll('[data-cart-key]')].find(el=>el.dataset.cartKey===key && el.getAttribute('aria-label')===label);
    if(focused && !focused.isConnected) (target || (isOpen() ? drawer().querySelector('.custom-cart-drawer__close') : document.querySelector('[data-gerhel-cart-status]')))?.focus({preventScroll:true});
  }
  async function fetchSections() {
    const url=new URL(location.href); url.searchParams.set('sections',sectionIds().join(','));
    const r=await fetch(url,{cache:'no-store',signal:AbortSignal.timeout(15000)});
    if(!r.ok) throw new Error('No se pudo actualizar la vista.'); return r.json();
  }
  async function reconcile() {
    const cart=await readCart(); badges(cart); render(await fetchSections()); uncertain=false; return cart;
  }
  async function refresh(options={}) {
    if(busy) return;
    lock(true);
    try { await reconcile(); announce('Carrito actualizado.'); if(options.keepOpen) open(); }
    catch { announce('No pudimos actualizar el carrito. Usa «Revisar carrito» antes de continuar.',true); }
    finally {lock(false);}
  }
  async function mutate(endpoint,body,{showDrawer=false,code=null}={}) {
    if(busy) return;
    if(uncertain) { await refresh(); return; }
    lock(true); announce('Actualizando carrito…');
    let accepted=false, rejected=false;
    try {
      const ids=sectionIds();
      if(body instanceof FormData) {body.set('sections',ids.join(','));body.set('sections_url',location.pathname+location.search);}
      else body={...body,sections:ids,sections_url:location.pathname+location.search};
      const r=await fetch(rootPath+endpoint,{method:'POST',headers:{Accept:'application/json',...(body instanceof FormData?{}:{'Content-Type':'application/json'})},body:body instanceof FormData?body:JSON.stringify(body),signal:AbortSignal.timeout(20000)});
      if(!r.ok) {
        rejected=r.status>=400 && r.status<500;
        const error=await r.json().catch(()=>null); throw new Error(error?.description || 'Shopify no pudo actualizar el carrito.');
      }
      accepted=true;
      const result=await r.json();
      if(showDrawer) open();
      const cart=endpoint==='cart/add.js'?await readCart():result;
      badges(cart);
      try {render(result.sections);} catch {render(await fetchSections());}
      if(code!==null) {
        const codes=cart.discount_codes || [];
        const match=codes.find(d=>d.code?.toLowerCase()===code.toLowerCase());
        const rendered=[...document.querySelectorAll('[data-applied-discount-code]')].some(el=>el.dataset.appliedDiscountCode.toLowerCase()===code.toLowerCase());
        const applied=match ? match.applicable===true : rendered;
        discountError=!applied;
        discountMessage=applied?'Código aplicado. Los totales incluyen el descuento.':'Este código no es válido o no es aplicable a este carrito.';
        restoreDiscount(); announce(discountMessage,discountError);
      } else announce('Carrito actualizado.');
      document.dispatchEvent(new CustomEvent('gerhel:cart-drawer:updated',{detail:{cart}}));
    } catch(error) {
      let recovered=false;
      try {await reconcile(); recovered=true;} catch {uncertain=!rejected;}
      if(showDrawer) open();
      const text=rejected?error.message:accepted
        ? (recovered?'El cambio se guardó y recuperamos la vista del carrito.':'El cambio se guardó, pero la vista no está disponible. Revisa el carrito antes de continuar.')
        : (recovered?'Se interrumpió la conexión. Revisa las cantidades actualizadas antes de volver a intentarlo.':'No pudimos confirmar el resultado. Revisa el carrito antes de volver a intentarlo.');
      announce(text,!accepted || !recovered);
      if(code!==null) {discountError=true;discountMessage='No pudimos confirmar el descuento por un error de conexión. El código se conserva para revisarlo.';restoreDiscount();}
    } finally {lock(false);}
  }
  function discount(container) {
    const input=container.querySelector('[data-cart-discount-input], [data-cart-page-discount-input]');
    draftCode=input?.value.trim() || '';
    if(!draftCode){discountMessage='Ingresa un código de descuento.';discountError=true;restoreDiscount();return;}
    const applied=[...document.querySelectorAll('[data-applied-discount-code]')].map(el=>el.dataset.appliedDiscountCode);
    mutate('cart/update.js',{discount:[...new Set([...applied,draftCode])].join(',')},{code:draftCode});
  }
  document.addEventListener('input',event=>{if(event.target.matches('[data-cart-discount-input], [data-cart-page-discount-input]')) draftCode=event.target.value;});
  document.addEventListener('submit',event=>{
    if(event.defaultPrevented) return;
    const form=event.target;
    if(form.matches('[data-cart-discount-form]')) {event.preventDefault();discount(form);return;}
    if(form.matches('[data-gerhel-cart-form]') && (!event.submitter?.name || event.submitter.name==='add')) {
      event.preventDefault(); if(!form.reportValidity()) return; mutate('cart/add.js',new FormData(form),{showDrawer:true});
    }
    if(form.closest('[data-gerhel-cart-section]') && (busy || uncertain)) {event.preventDefault();announce('Espera a que se confirme el carrito antes de continuar.',true);}
  });
  document.addEventListener('click',event=>{
    const el=event.target.closest('[data-cart-drawer-close], [data-cart-drawer-quantity], [data-cart-page-quantity], [data-cart-upsell-add], [data-cart-page-upsell-add], [data-cart-page-discount-apply], [data-gerhel-cart-retry]');
    if(!el) return; event.preventDefault();
    if(el.matches('[data-cart-drawer-close]')) {close();return;}
    if(el.matches('[data-gerhel-cart-retry]')) {refresh();return;}
    if(busy) return;
    if(el.matches('[data-cart-page-discount-apply]')) discount(el.closest('[data-cart-page-discount-form]'));
    else if(el.dataset.cartKey) {const quantity=Number(el.dataset.quantity);if(Number.isInteger(quantity)&&quantity>=0) mutate('cart/change.js',{id:el.dataset.cartKey,quantity});}
    else if(el.dataset.variantId) mutate('cart/add.js',{id:el.dataset.variantId,quantity:1},{showDrawer:!el.matches('[data-cart-page-upsell-add]')});
  });
  document.addEventListener('keydown',event=>{
    if(event.key==='Enter' && event.target.matches('[data-cart-page-discount-input]')) {event.preventDefault();discount(event.target.closest('[data-cart-page-discount-form]'));}
    if(!isOpen()) return;
    if(event.key==='Escape') {event.preventDefault();close();}
    if(event.key==='Tab') {
      const items=[...drawer().querySelector('.custom-cart-drawer__panel').querySelectorAll('a[href],button:not(:disabled),input:not(:disabled),[tabindex="0"]')].filter(el=>el.getClientRects().length);
      const first=items[0],last=items.at(-1);
      if(event.shiftKey && (document.activeElement===first || !drawer().contains(document.activeElement))) {event.preventDefault();last?.focus();}
      else if(!event.shiftKey && (document.activeElement===last || !drawer().contains(document.activeElement))) {event.preventDefault();first?.focus();}
    }
  });
  document.addEventListener('focusin',event=>{if(isOpen() && !drawer().contains(event.target)) drawer().querySelector('.custom-cart-drawer__close')?.focus();});
  document.addEventListener('gerhel:cart-drawer:open',event=>{open();if(event.detail?.refresh) refresh();});
  document.addEventListener('cart:refresh-and-open',()=>{open();refresh();});
  document.addEventListener('shopify:section:load',()=>{syncSummary();if(drawer()) drawer().inert=!isOpen();});
  syncSummary();
  if(drawer()) drawer().inert=true;
  window.GerhelCartDrawer={open,close,refresh};
})();
